import { useNavigate } from "react-router-dom";
import "./PrivacyPolicy.css";
import TallyLogo from "../assets/Tally_Logotype_Offwhite_01.png";

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <div className="policy-container">
      <img
        src={TallyLogo}
        alt="Tally Logo"
        className="viewport-logo"
        onClick={handleLogoClick}
      />

      <header>
        <h1>Privacy Policy</h1>
        <p className="last-updated">
          Last updated: <strong>August 10, 2025</strong>
        </p>
      </header>

      <section>
        <h2>1. Data Controller</h2>
        <p>
          <strong>Tally ApS</strong> is committed to protecting your personal
          data and respecting your privacy. We act as the data controller
          responsible for managing your information in accordance with
          applicable laws.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>
          We collect only the personal data necessary to provide and improve our
          services, including:
        </p>
        <ul>
          <li>
            <strong>Account Information:</strong> Your name, email address, and
            profile details when you create or sign into your account.
          </li>
          <li>
            <strong>Google Drive Files:</strong> When you connect your Google
            Drive, we may access spreadsheets and other files you explicitly
            choose to share with Tally, solely to provide the services you
            request.
          </li>
          <li>
            <strong>User Content:</strong> Any information or documents you
            upload, store, or process through our services.
          </li>
          <li>
            <strong>Service Usage Data:</strong> Logs and analytics data to help
            us understand how our service is used and improve performance.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Data</h2>
        <p>Your data is used to:</p>
        <ul>
          <li>
            Provide, maintain, and enhance the Tally personal business assistant
            services.
          </li>
          <li>Authenticate and identify you securely when you sign in.</li>
          <li>
            Communicate important updates, support, and administrative
            information.
          </li>
          <li>Comply with legal and regulatory requirements.</li>
        </ul>
      </section>

      <section>
        <h2>4. Data Sharing and Disclosure</h2>
        <p>
          We do not sell your personal data. We may share your information only
          in limited circumstances:
        </p>
        <ul>
          <li>
            With trusted third-party service providers who assist us in
            operating the service, bound by confidentiality agreements.
          </li>
          <li>When required by law or legal process.</li>
          <li>
            With your explicit consent for integrations and additional services
            you enable, including Google Drive file access.
          </li>
          <li>
            With Google's services when you choose to connect your Google Drive
            account, limited to the specific files you authorize.
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Data Retention</h2>
        <p>
          We retain your personal data only as long as necessary to fulfill the
          purposes described in this policy or as required by law. You can
          request data deletion at any time by contacting us.
        </p>
      </section>

      <section>
        <h2>6. Your Rights</h2>
        <p>
          You have the right to access, correct, or request deletion of your
          personal data. You may also object to or restrict certain processing
          of your data. To exercise these rights, please contact us at{" "}
          <a href="mailto:[info@asktally.com]">info@asktally.com</a>.
        </p>
      </section>

      <footer>
        <p>
          This Privacy Policy applies to data collected through our website and
          services, including Google OAuth integration. For questions, contact
          us at <a href="mailto:[info@asktally.com]">info@asktally.com</a>.
        </p>
      </footer>
    </div>
  );
}
